import React from "react";

import ApplicationPayment from "~/components/application/sections/payment";
import ApplicationSuccessful from "~/components/application/sections/success";
import MainButton from "~/components/common/mainButton";
import { Loader } from "~/components/ui/loader";
import Modal from "~/components/ui/modal";
import { useAuth } from "~/contexts/providers/auth";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";
import { UserStatus } from "~/types/auth/userEnums.types";

import styles from "./index.module.scss";

const PrivatePage: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { user, setUser } = useAuth();
  const { language } = useLanguage();

  const modalOpen =
    user?.status &&
    [UserStatus.CONFIRMED_PAYMENT, UserStatus.CONFIRMED_COGNITO].includes(
      user.status
    );

  const applyTexts =
    language === "En"
      ? englishTranslations.applyPage
      : frenchTranslations.applyPage;

  const handlePaymentSuccess = () => {
    if (user) {
      setUser({ ...user, status: UserStatus.CONFIRMED_PAYMENT });
    }
  };

  return user?.id ? (
    <>
      {children}
      <Modal open={false}>
        <div className={styles.modalContainer}>
          {user.status === UserStatus.CONFIRMED_COGNITO ? (
            <>
              <p>{applyTexts.header}</p>
              <ApplicationPayment handleNext={handlePaymentSuccess} />
            </>
          ) : (
            <ApplicationSuccessful />
          )}
          <MainButton href="/" style={{ textTransform: "none" }}>
            {applyTexts.back}
          </MainButton>
        </div>
      </Modal>
    </>
  ) : (
    <div className={styles.container}>
      <Loader />
    </div>
  );
};

export default PrivatePage;
